var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#38c20a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.5,17.693l2.194-4.288-4.045-2.614L29.4,5.981l-4.81-.24L21.978,1.7l-4.286,2.2L13.4,1.7,10.791,5.746l-4.81.243L5.74,10.8,1.7,13.416l2.2,4.286L1.7,21.988,5.746,24.6l.243,4.81,4.81.24L13.415,33.7,17.7,31.5l4.288,2.194L24.6,29.647l4.81-.243.242-4.81L33.7,21.978Zm-15.7,5.2-4.683-4.682,1.456-1.456L15.824,20l7-6.789,1.434,1.479Z",
    transform: "translate(-1.696 -1.697)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.5b1476a20cdfe6a3611324b4237e01f5.svg";
export { ForwardRef as ReactComponent };